import { useMutation, useQuery } from "@tanstack/react-query";
import { get, post, put } from "../../api/client";
import { getValue } from "../../utils/object.utils";

export const TEACHERS_KEYS = {
  TEACHER: "TEACHER",
  TEACHERS_LIST: "TEACHERS_LIST",
};

export const useRegisterTeacher = () =>
  useMutation((body: any) => {
    return post({
      url: "api/v1/user/register-teacher",
      body: {
        first_name: getValue(body, "firstName"),
        middle_name: getValue(body, "middleName"),
        last_name: getValue(body, "lastName"),
        email: getValue(body, "email"),
        password: getValue(body, "password"),
        mobile: getValue(body, "mobile"),
        address: getValue(body, "address"),
        base_salary: getValue(body, "baseSalary"),
        job_type: getValue(body, "jobType"),
        school_block_id: getValue(body, "schoolBlockId"),
        school_branch_id: getValue(body, "schoolBranchId"),
        subject_ids: getValue(body, "subjectIds", []),
        class_id: getValue(body, "classId"),
      },
    });
  });

export const useListTeacher = () =>
  useQuery([TEACHERS_KEYS.TEACHERS_LIST], () => get({ url: "api/v1/teacher" }));

export const useGetTeacherById = ({ teacherId }: { teacherId: number }) =>
  useQuery([teacherId, TEACHERS_KEYS.TEACHER], () =>
    get({ url: `api/v1/teacher/${teacherId}` })
  );

export const useUpdateTeacher = ({ teacherId }: { teacherId: number }) => {
  return useMutation((body: object) => {
    return put({
      url: `api/v1/teacher/update-teacher-admin/${teacherId}`,
      body: {
        first_name: getValue(body, "firstName"),
        middle_name: getValue(body, "middleName"),
        last_name: getValue(body, "lastName"),
        email: getValue(body, "email"),
        mobile: getValue(body, "mobile"),
        address: getValue(body, "address"),
        school_block_id: getValue(body, "school_block_id"),
        school_branch_id: getValue(body, "schoolBranchId"),
        job_type: getValue(body, "jobType"),
        base_salary: getValue(body, "baseSalary"),
      },
    });
  });
};

export const useGetStudentsForTeacher = (teacherId: number) => {
  return useQuery([teacherId], () =>
    get({ url: `api/v1/teacher/teachers-students/${teacherId}` })
  );
};
